/**
 * Ek mesai daveti yardımcıları (30.10.2026, #514). Yeni talepte (geçmiş tarihli de, 02.11.2026) kişi sayısı kadar personel
 * seçilir, davet gider. Davetsiz açılmış eski geçmiş tarihli kayıt düzenlenince eskisi gibi kalır. Sunucu da aynı kuralı denetler.
 */

export const DAVET_BEKLIYOR = 1;
export const DAVET_KALIYOR = 2;
export const DAVET_KALAMIYOR = 3;

/** "2026-10-30" + "20:00": bitiş şimdiden sonra mı. Saat henüz seçilmediyse gün bazında bakılır. */
export const davetZorunlu = (tarih: string | undefined, bitis: string | undefined, simdi: Date = new Date()): boolean => {
    if (!tarih)
        return true;
    const [y, a, g] = tarih.substring(0, 10).split('-').map(Number);
    const [s, d] = (bitis ?? '23:59').split(':').map(Number);
    return new Date(y, a - 1, g, s, d).getTime() > simdi.getTime();
}

/** Personel zorunlu mu: yeni talep, geçmiş tarihli daveti olan talep ya da bitişi geçmemiş talep. */
export const personelZorunluMu = (yeniTalep: boolean, gecmisDavet: boolean | undefined, tarih: string | undefined, bitis: string | undefined, simdi: Date = new Date()): boolean =>
    yeniTalep || !!gecmisDavet || davetZorunlu(tarih, bitis, simdi);

export const personelSayiHatasi = (zorunlu: boolean, secilen: number, kisi: number): string | null => {
    if (secilen > kisi)
        return `Seçilen personel (${secilen}) kişi sayısından (${kisi}) fazla olamaz.`;
    if (zorunlu && secilen != kisi)
        return `${kisi} personel seçiniz (seçilen: ${secilen}).`;
    return null;
}

export const davetDurumu = (durum: number | null | undefined): { metin: string, sinif: string } => {
    switch (durum) {
        case DAVET_KALIYOR: return { metin: 'Kalıyor', sinif: 'badge-light-success' };
        case DAVET_KALAMIYOR: return { metin: 'Kalamıyor', sinif: 'badge-light-danger' };
        case DAVET_BEKLIYOR: return { metin: 'Bekliyor', sinif: 'badge-light-warning' };
        default: return { metin: 'Davetsiz', sinif: 'badge-light' };
    }
}

interface DavetSatiri { ad: string, davetDurumu?: number | null }

/** Liste kolonu ve Excel: "Kalıyor: Ali · Bekliyor: Veli · Kalamıyor: Can". Davetsiz eski satır yazılmaz. */
export const davetOzeti = (ayrilanlar: DavetSatiri[] | undefined, reddedenler: DavetSatiri[] | undefined): string =>
    [DAVET_KALIYOR, DAVET_BEKLIYOR, DAVET_KALAMIYOR]
        .map(d => ({ d, adlar: [...(ayrilanlar ?? []), ...(reddedenler ?? [])].filter(x => x.davetDurumu == d).map(x => x.ad) }))
        .filter(x => x.adlar.length > 0)
        .map(x => `${davetDurumu(x.d).metin}: ${x.adlar.join(', ')}`)
        .join(' · ');
